import {Button} from 'antd';
import {useState} from 'react';

import {appRoute} from '../../../../app-route';
import {NavigationLink} from '../../../../layout/navigation-link/navigation-link';
import {Locale} from '../../../../provider/locale/locale';
import {LangKeyType} from '../../../../provider/locale/translation/type';
import {PostsTabEnum} from '../posts-const';
import {
    PublicationCreateFormModal,
    PublicationFormEnum,
} from '../publication-create-form-modal/publication-create-form-modal';

const FORM_BY_TAB: Partial<Record<PostsTabEnum, {form: PublicationFormEnum; labelLangKey: LangKeyType}>> = {
    [PostsTabEnum.Stories]: {form: PublicationFormEnum.Story, labelLangKey: 'POSTS__TAB__CREATE_STORY'},
    [PostsTabEnum.Promotions]: {form: PublicationFormEnum.Promotion, labelLangKey: 'POSTS__TAB__CREATE_PROMOTION'},
    [PostsTabEnum.Events]: {form: PublicationFormEnum.Event, labelLangKey: 'POSTS__TAB__CREATE_EVENT'},
};

type PostsCreateButtonPropsType = {
    activeTab: PostsTabEnum;
    isLicenseExpired: boolean;
};

export function PostsCreateButton({activeTab, isLicenseExpired}: PostsCreateButtonPropsType): JSX.Element {
    const {postsManagementCreatePost} = appRoute;
    const [openedForm, setOpenedForm] = useState<PublicationFormEnum | null>(null);

    const tabForm = FORM_BY_TAB[activeTab];

    if (tabForm) {
        return (
            <>
                <Button disabled={isLicenseExpired} onClick={() => setOpenedForm(tabForm.form)} type="primary">
                    <Locale stringKey={tabForm.labelLangKey} />
                </Button>

                <PublicationCreateFormModal form={openedForm} onClose={() => setOpenedForm(null)} />
            </>
        );
    }

    return (
        <NavigationLink to={postsManagementCreatePost.path}>
            <Button disabled={isLicenseExpired} type="primary">
                <Locale stringKey="POSTS__TAB__CREATE_POST" />
            </Button>
        </NavigationLink>
    );
}
